import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { fromISODate, toISODate } from '@/shared/lib'
import { CalendarBoard, useDefaultCalendarView } from '@/widgets/calendar-board'

const searchSchema = z.object({
  view: z.enum(['day', 'week', 'month']).optional().catch(undefined),
  date: z.string().optional().catch(undefined),
})

export const Route = createFileRoute('/_app/stit')({
  validateSearch: (search: Record<string, unknown>) => searchSchema.parse(search),
  component: StitCalendarPage,
})

// Календарь всей студии: та же сетка, что «Мой календарь», на линзе team —
// все события системы за период (GET /api/calendar/team, срез даёт бэк).
function StitCalendarPage() {
  const search = Route.useSearch()
  const navigate = Route.useNavigate()
  const defaultView = useDefaultCalendarView()
  const view = search.view ?? defaultView
  const anchor = (search.date ? fromISODate(search.date) : null) ?? new Date()

  return (
    <div className="flex h-full min-h-0 flex-col">
      <CalendarBoard
        lens={{ kind: 'team' }}
        view={view}
        anchor={anchor}
        onViewChange={(v) => void navigate({ search: (s) => ({ ...s, view: v }) })}
        onAnchorChange={(d) => void navigate({ search: (s) => ({ ...s, date: toISODate(d) }) })}
      />
    </div>
  )
}
